import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import c from 'classnames';
import s from './MediumSophisticatedTooltipHeading.scss';
const MediumSophisticatedTooltipHeading = (_param)=>/*#__PURE__*/ {
    var { children, className } = _param, rest = _object_without_properties(_param, [
        "children",
        "className"
    ]);
    return React.createElement("span", _object_spread({
        className: c(s['root'], className)
    }, rest), children);
};
MediumSophisticatedTooltipHeading.displayName = 'MediumSophisticatedTooltipHeading';
export default MediumSophisticatedTooltipHeading;
